import React from 'react';
import PropTypes from 'prop-types';

import { Cell, Grid } from 'react-md';
import { get, map, sortBy } from 'lodash-es';

import PercentField from '../../Common/PercentField';
import Select from '../../Common/Select';

const DefaultFieldsComponent = ({ data, strings, isLoan, readOnly, values }) => {
  const packageOptions = sortBy(
    map(get(data, 'package'), (p, key) => ({ value: key, text: p.name, sequence: p.sequence })),
    'sequence'
  );

  const initialValue = get(values, 'package');

  return (
    <Grid className="grid default">
      {packageOptions.length > 0 ? (
        <div key="package" className={Cell.getClassName({ size: 5 })}>
          <Select
            className="field select"
            key="package"
            field="package"
            id="select-package"
            name="package"
            shrink
            label={strings['block.covered.field.package.label']}
            options={packageOptions}
            initialValue={initialValue}
            disabled={readOnly}
            required
          />
        </div>
      ) : undefined}
      {isLoan ? (
        <div key="share" className={Cell.getClassName({ size: 7 })}>
          <PercentField
            className="field percent"
            key="share"
            field="share"
            id="numberfield-share"
            name="share"
            shrink
            label={strings['block.covered.field.share.label']}
            placeholder=""
            disabled={readOnly}
            initialValue={get(values, 'share', 100)}
            ratio={1}
            required
          />
        </div>
      ) : undefined}
    </Grid>
  );
};

DefaultFieldsComponent.propTypes = {
  data: PropTypes.any.isRequired, // eslint-disable-line react/forbid-prop-types
  strings: PropTypes.objectOf(PropTypes.string).isRequired,
  onSave: PropTypes.func, // eslint-disable-line
  values: PropTypes.any.isRequired, // eslint-disable-line react/forbid-prop-types
  readOnly: PropTypes.bool.isRequired,
  isLoan: PropTypes.bool.isRequired,
};

DefaultFieldsComponent.defaultProps = {};

export default DefaultFieldsComponent;
